import Facebook from '@/icons/social-facebook.svg';
import Linkedin from '@/icons/social-linkedin.svg';

export const SITE_NAME = 'PDFe';

export const FILE_TYPES = ['image/png', 'image/jpeg'];
export const MAX_SIZE_MB = 100;

export const STORAGE_DAYS = 7;
export const TRIAL_DAYS = 7;
export const TRIAL_DISCOUNT_DAYS = 7;
export const DOCUMENTS_TRIAL_LIMIT = 3;
export const DOCUMENT_TTL_HOURS = 24;

export const COMPANY_LEGAL_NAME = 'The Internet Company Group S.L';
export const COMPANY_NAME = 'PDFe';
export const COMPANY_URL = 'https://pdfe.com';
export const SUPPORT_EMAIL = 'support@pdfe.com';
export const DISPUTE_LINK = 'http://ec.europa.eu/odr';
export const COMPANY_ADDRESS =
	'Av. Cerdanyola, 75, CP 08172, Sant Cugat del Vallés, Barcelona, Spain';
export const TAX_ID = 'B21684139';
export const defaultLocale = 'en';

export const REVIEW_URL = 'https://www.trustpilot.com/evaluate/pdfe.com';

export const SENTRY_ENABLED = !!import.meta.env.VITE_SENTRY_DSN;

export const EXTERNAL_LINKS = {
	stripeCookes: 'https://stripe.com/legal/cookies-policy',
	cloudflareCookies: 'https://www.cloudflare.com/es-es/cookie-policy/',
	dpaLink: 'https://www.aepd.es/derechos-y-deberes/ejerce-tus-derechos',
	sadpLink: 'https://www.aepd.es/'
};

export const EXTERNAL_COOKIES_LINKS = [
	{
		label: 'Edge',
		url: 'https://support.microsoft.com/en-us/windows/microsoft-edge-browsing-data-and-privacy-bb8174ba-9d73-dcf2-9b4a-c582b4e640dd'
	},
	{
		label: 'Google Chrome',
		url: 'https://support.google.com/chrome/answer/95647?hl=en'
	},
	{
		label: 'Google Android',
		url: 'https://support.google.com/chrome/answer/114662?hl=en&visit_id=1-636664625754483085-1648636281&rd=1&co=GENIE.Platform=Android&oco=1'
	},
	{
		label: 'Internet Explorer 8',
		url: 'https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies'
	},
	{
		label: 'Internet Explorer 9',
		url: 'https://support.microsoft.com/es-es/help/278835/how-to-delete-cookie-files-in-internet-explorer'
	},
	{
		label: 'Internet Explorer 11',
		url: 'https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies#ie=ie-10'
	},
	{
		label: 'Mozilla Firefox',
		url: 'https://support.mozilla.org/en-US/kb/block-websites-storing-cookies-site-data-firefox'
	},
	{
		label: 'Opera',
		url: 'https://help.opera.com/en/latest/web-preferences/#cookies'
	},
	{
		label: 'Safari',
		url: 'https://support.apple.com/kb/ph21411?locale=es_ES'
	},
	{
		label: 'Safari Mobile',
		url: 'https://support.apple.com/es-es/HT201265'
	}
];

export const SOCIALS = [
	{
		Icon: Facebook,
		key: 'Facebook',
		url: 'http://facebook.com/pdfecom'
	},
	{
		Icon: Linkedin,
		key: 'Linkedin',
		url: 'https://www.linkedin.com/company/pdfe-com'
	}
];

export const PAYMENT_HANDLER = 'adyen';

export const invoiceDelayHours = 72;

export const AMEX_SETTLEMENT_DAYS = 10;

export const TRUSTPILOT_RATING_VALUE = 4.2;

export const TRUSTPILOT_RATING_COUNT = 95_023;
